import React, {useState} from "react";
import {connect} from "react-redux";
import {AirlineCreateRoute, AirplaneCreateRoute, AirplaneEditRoute} from "../../../routesConstants";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import {Link} from "react-router-dom";
import DataTable from "../../../../components/dataTable";
import PortletHeaderSearch from "../../../base/components/forms/portlerHeaderSearch";
import {Col, Row, Tab, Tabs} from "react-bootstrap";
import Process from "../../../../components/process";
import {Helmet} from "react-helmet";

const AirplaneList = (props)=>{
  const columns = [
    {
      Header: 'Оригинальное название',
      accessor: 'originalName',
      Cell: ({value, row}) => <Link to={AirplaneEditRoute + row.original._id } >{value}</Link>
    },
    {
      Header: 'Название',
      accessor: 'name',
    },
    {
      Header: 'ISO код самолета',
      accessor: 'iataCode',
    },
    {
      Header: "Действия",
      Cell: ({value, row}) => (<Link className={"btn btn-sm btn-clean btn-icon btn-icon-md"} to={AirplaneEditRoute + row.original._id}><i className={"la la-edit"}/></Link>)
    }
  ]

  const [query, setQuery] = useState("");
  const [tabIndex, setTabIndex] = useState("home");
  return <>
    <Helmet>
      <title>Самолеты</title>
    </Helmet>
    <Tabs
      variant="pills"
      id="controlled-tab-example"
      activeKey={tabIndex}
      onSelect={key => setTabIndex(key)}
    >
      <Tab eventKey="home" title="Список">
        <div className={"kt-grid__item"}>
          <Portlet>
            <PortletHeader
              title={"Список самолетов"}
              toolbar={
                <PortletHeaderToolbar>
                  <PortletHeaderSearch value={query} cb={(v)=>{setQuery(v)}}/>
                  <Link
                    to={AirplaneCreateRoute}
                    className="btn btn-sm btn-brand btn-elevate btn-icon-sm"
                  >
                    <i className="la la-plus" />
                    Добавить
                  </Link>
                </PortletHeaderToolbar>}
            />
            <PortletBody>
              <DataTable columns={columns} search={query} url={`/api/air/airplanes`}/>
            </PortletBody>
          </Portlet>
        </div>
      </Tab>

      <Tab eventKey="profile" title="Действия"  className="tab-no-background">
        <Row>
          <Col md={6}>
            <Process desc={"Забирает с flightStats все самолеты и загружает к нам в базу"}
                     title={"Синхронизация самолетов"}
                     link={"/api/air/airplanes/syncAirplanes"}
            />
          </Col>
        </Row>
      </Tab>
    </Tabs>
  </>
}


export default connect(null)(AirplaneList)
